import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

export function SubscriptionsTableSkeleton() {
  return Array.from({ length: 3 }).map((_, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <TableRow key={i} data-testid="subscription-row-skeleton">
      <TableCell className="w-16" />
      <TableCell>
        <Skeleton className="h-12" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-12" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-12" />
      </TableCell>
    </TableRow>
  ));
}
